import { IVolumeAlignment } from "../PA.TPM.Services/VolumeAlignmentUtils"

export interface IMetricParameters {

  MetricParameterId: string;

  Sources: number[];    // WB_Source_ID

  PlanningCustomers: number[] // WB_CUST_ID
  SourceCustomers: number[]   // WB_CUST_ID

  FinishedProducts: number[]    // WB_PROD_ID
  OrderFinishedProduct?: number[] // WB_PROD_ID_ORDER
  ConsumerProductUPCs: string[]  // Consumer UPCs

  SalesArea?: number[] // WB_SALESAREA_ID
  SalesOrg?: number[] // WB_SALESORG_ID

  ConsumptionAdjustmentsPGs: number[] // WB_CNSPG_ID
  ProductGroups?: number[]

  InStoreStartDt: Date
  InStoreEndDt: Date
  ShipmentStartDt: Date
  ShipmentEndDt: Date

  bIncludeAdjustments: boolean
  bIncludeEDLPSplit: boolean

  bCalculateIntersection: boolean
  Int_InStoreStartDt: Date
  Int_InStoreEndDt: Date
  Int_ShipmentStartDt: Date
  Int_ShipmentEndDt: Date

  VolumeAlignment?: IVolumeAlignment
  Int_VolumeAlignment?: IVolumeAlignment
}

export interface IMetricParameterSet {
  [id: string]: IMetricParameters
}


export interface IMetrics {

  clone(): IMetrics
  subtract(aMetrics: IMetrics, mtrFields?: string[], bExcludeIntersect?: boolean): void
  add(aMetrics: IMetrics, mtrFields?: string[], bExcludeIntersect?: boolean): void
  scaleBy(aScaleFactor: number): void

  IntersectionMetrics: IMetrics
  CalcError: any

  // copy interface IwbMetric { ... same names, exclude SPEND,  Compound Metrics & adjacent metrics
  "CNSMP_BASE_UNITS"?: number;
  "CNSMP_BASE_WT"?: number;
  "CNSMP_BASE_STAT"?: number;
  "CNSMP_BASE_LISTSLS"?: number;
  "CNSMP_BASE_NETLISTSLS"?: number;
  "CNSMP_BASE_RTLSLS"?: number;
  "CNSMP_BASE_PRFTCNTRB"?: number;
  "CNSMP_EDLP_UNITS"?: number;
  "CNSMP_EDLP_WT"?: number;
  "CNSMP_EDLP_STAT"?: number;
  "CNSMP_EDLP_LISTSLS"?: number;
  "CNSMP_EDLP_NETLISTSLS"?: number;
  "CNSMP_EDLP_RTLSLS"?: number;
  "CNSMP_EDLP_PRFTCNTRB"?: number;
  "CNSMP_INCR_UNITS"?: number;
  "CNSMP_INCR_WT"?: number;
  "CNSMP_INCR_STAT"?: number;
  "CNSMP_INCR_LISTSLS"?: number;
  "CNSMP_INCR_NETLISTSLS"?: number;
  "CNSMP_INCR_RTLSLS"?: number;
  "CNSMP_INCR_PRFTCNTRB"?: number;
  "CNSMP_DISP_INCR_UNITS"?: number;
  "CNSMP_DISP_INCR_WT"?: number;
  "CNSMP_DISP_INCR_STAT"?: number;
  "CNSMP_DISP_INCR_LISTSLS"?: number;
  "CNSMP_DISP_INCR_NETLISTSLS"?: number;
  "CNSMP_DISP_INCR_RTLSLS"?: number;
  "CNSMP_DISP_INCR_PRFTCNTRB"?: number;
  "CNSMP_TOTAL_UNITS"?: number;
  "CNSMP_TOTAL_WT"?: number;
  "CNSMP_TOTAL_STAT"?: number;
  "CNSMP_TOTAL_LISTSLS"?: number;
  "CNSMP_TOTAL_NETLISTSLS"?: number;
  "CNSMP_TOTAL_RTLSLS"?: number;
  "CNSMP_TOTAL_PRFTCNTRB"?: number;
  "CNSMP_PROMO_UNITS"?: number;
  "CNSMP_PROMO_WT"?: number;
  "CNSMP_PROMO_STAT"?: number;
  "CNSMP_PROMO_LISTSLS"?: number;
  "CNSMP_PROMO_NETLISTSLS"?: number;
  "CNSMP_PROMO_RTLSLS"?: number;
  "CNSMP_PROMO_PRFTCNTRB"?: number;
  "CNSMP_NONPROMO_UNITS"?: number;
  "CNSMP_NONPROMO_WT"?: number;
  "CNSMP_NONPROMO_STAT"?: number;
  "CNSMP_NONPROMO_LISTSLS"?: number;
  "CNSMP_NONPROMO_NETLISTSLS"?: number;
  "CNSMP_NONPROMO_RTLSLS"?: number;
  "CNSMP_NONPROMO_PRFTCNTRB"?: number;
  "MERCH_FEATUREONLY_ACV_N"?: number;
  "MERCH_DISPLAYONLY_ACV_N"?: number;
  "MERCH_FEATUREDISPLAY_ACV_N"?: number;
  "MERCH_TPRONLY_ACV_N"?: number;
  "MERCH_PROMOTED_ACV_N"?: number;
  "MERCH_DIST_ACV_N"?: number;
  "MERCH_ACV_D"?: number;
  "MERCH_FEATUREONLY_UNITS"?: number;
  "MERCH_DISPLAYONLY_UNITS"?: number;
  "MERCH_FEATUREDISPLAY_UNITS"?: number;
  "MERCH_TPRONLY_UNITS"?: number;
  "MERCH_PROMOTED_UNITS"?: number;
  "SHIPMENT_ORDER_QTY"?: number,
  "SHIPMENT_BUOM_QTY"?: number,
  "SHIPMENT_UNITS"?: number;
  "SHIPMENT_WT"?: number;
  "SHIPMENT_STAT"?: number;
  "SHIPMENT_LISTSLS"?: number;
  "SHIPMENT_NETLISTSLS"?: number;
  "SHIPMENT_PRFTCNTRB"?: number;
  "RETURN_ORDER_QTY"?: number,
  "RETURN_BUOM_QTY"?: number,
  "RETURN_UNITS"?: number;
  "RETURN_WT"?: number;
  "RETURN_STAT"?: number;
  "RETURN_LISTSLS"?: number;
  "RETURN_NETLISTSLS"?: number;
  "RETURN_PRFTCNTRB"?: number;

  // computed measures
  "LIST_PRICE"?: number;
  "LIFT_BYUNITS_PCNT"?: number;
  "LIFT_BYWT_PCNT"?: number;
  "VCM_CNSMP_INCR_PCNT"?: number;
  "VCM_CNSMP_PCNT"?: number;
  "VCM_SHIP_PCNT"?: number;
  "RETAILER_BASE_PRICE"?: number;
  "RETAILER_PROMOTED_PRICE"?: number;
  "RETAILER_AVG_PRICE"?: number;
  "MERCH_FEATUREONLY_ACV_PCNT"?: number;
  "MERCH_DISPLAYONLY_ACV_PCNT"?: number;
  "MERCH_FEATUREDISPLAY_ACV_PCNT"?: number;
  "MERCH_TPRONLY_ACV_PCNT"?: number;
  "MERCH_PROMOTED_ACV_PCNT"?: number;
  "MERCH_DIST_ACV_PCNT"?: number;
  "CNSMP_SYND_BASE_UNITS"?: number;
  "CNSMP_SYND_BASE_WT"?: number;
  "CNSMP_SYND_BASE_STAT"?: number;
  "CNSMP_SYND_BASE_LISTSLS"?: number;
  "CNSMP_SYND_BASE_NETLISTSLS"?: number;
  "CNSMP_SYND_BASE_RTLSLS"?: number;
  "CNSMP_SYND_BASE_PRFTCNTRB"?: number;
  "SHIPMENT_LIST_PRICE"?: number;
  "SHIPMENT_INVOICE_PRICE"?: number;
  "SHIPMENT_LIST_PRICE_ORDER"?: number;
  "SHIPMENT_INVOICE_PRICE_ORDER"?: number;
  [id: string]: any
}

export interface IMetricsSet {
  [id: string]: IMetrics
}

export interface IMetricDetailRow {
  Key: string

  PlanningCustomer?: number
  SourceCustomer?: number
  Product?: number
  ConsumerProductUPC?: string,
  Source?: number,
  Date: Date

  Metrics: IMetrics
}

export interface IMetricDetails {

  DetailRows: IMetricDetailRow[]

  CalcError: any

  [id: string]: any
}


export interface IMetricDetailsSet {
  [id: string]: IMetricDetails
}

export enum DetailAttributes {
  PlanningCustomer = "PlanningCustomer",
  SourceCustomer   = "SourceCustomer",
  Product          = "Product",
  ConsumerUPC      = "ConsumerProduct",
  Date             = "Date",
  Source           = "Source"
}

export interface IMetricDetailsOptions {
  Attributes: DetailAttributes[]
}

export interface IMetricService {
  calculateMetric(metric_parameter: IMetricParameters):Promise<IMetrics>
  calculateMetricSet(metric_parameter_set: IMetricParameterSet): Promise<IMetricsSet>

  calculateMetricDetails(metric_parameter: IMetricParameters, detailOptions: IMetricDetailsOptions):Promise<IMetricDetails>
  calculateMetricDetailsSet(metric_parameter_set: IMetricParameterSet, detailOptions: IMetricDetailsOptions): Promise<IMetricDetailsSet>

  calculateMetricUnion(metric_parameters: IMetricParameters[]):Promise<IMetrics[]>
  calculateMetricUnionDetails(metric_parameters: IMetricParameterSet, detailOptions: IMetricDetailsOptions):Promise<IMetricDetailsSet>

}


// Constant Helper Fields

export const Metric_Base_Fields = [
  'CNSMP_BASE_UNITS',
  'CNSMP_BASE_WT',
  'CNSMP_BASE_STAT',
  'CNSMP_BASE_LISTSLS',
  'CNSMP_BASE_NETLISTSLS',
  'CNSMP_BASE_RTLSLS',
  'CNSMP_BASE_PRFTCNTRB']

export const Metric_EDLP_Fields = [
  'CNSMP_EDLP_UNITS',
  'CNSMP_EDLP_WT',
  'CNSMP_EDLP_STAT',
  'CNSMP_EDLP_LISTSLS',
  'CNSMP_EDLP_NETLISTSLS',
  'CNSMP_EDLP_RTLSLS',
  'CNSMP_EDLP_PRFTCNTRB']

export const Metric_Merch_Incr_Fields = [
  'CNSMP_INCR_UNITS',
  'CNSMP_INCR_WT',
  'CNSMP_INCR_STAT',
  'CNSMP_INCR_LISTSLS',
  'CNSMP_INCR_NETLISTSLS',
  'CNSMP_INCR_RTLSLS',
  'CNSMP_INCR_PRFTCNTRB']

export const Metric_Display_Incr_Fields = [
  'CNSMP_DISP_INCR_UNITS',
  'CNSMP_DISP_INCR_WT',
  'CNSMP_DISP_INCR_STAT',
  'CNSMP_DISP_INCR_LISTSLS',
  'CNSMP_DISP_INCR_NETLISTSLS',
  'CNSMP_DISP_INCR_RTLSLS',
  'CNSMP_DISP_INCR_PRFTCNTRB']

export const Metric_Total_Fields = [
  'CNSMP_TOTAL_UNITS',
  'CNSMP_TOTAL_WT',
  'CNSMP_TOTAL_STAT',
  'CNSMP_TOTAL_LISTSLS',
  'CNSMP_TOTAL_NETLISTSLS',
  'CNSMP_TOTAL_RTLSLS',
  'CNSMP_TOTAL_PRFTCNTRB']

export const Metric_Promo_Fields = [
  'CNSMP_PROMO_UNITS',
  'CNSMP_PROMO_WT',
  'CNSMP_PROMO_STAT',
  'CNSMP_PROMO_LISTSLS',
  'CNSMP_PROMO_NETLISTSLS',
  'CNSMP_PROMO_RTLSLS',
  'CNSMP_PROMO_PRFTCNTRB']

export const Metric_NonPromo_Fields = [
  'CNSMP_NONPROMO_UNITS',
  'CNSMP_NONPROMO_WT',
  'CNSMP_NONPROMO_STAT',
  'CNSMP_NONPROMO_LISTSLS',
  'CNSMP_NONPROMO_NETLISTSLS',
  'CNSMP_NONPROMO_RTLSLS',
  'CNSMP_NONPROMO_PRFTCNTRB']

export const Metric_Merch_Fields = [
  'MERCH_FEATUREONLY_ACV_N',
  'MERCH_DISPLAYONLY_ACV_N',
  'MERCH_FEATUREDISPLAY_ACV_N',
  'MERCH_TPRONLY_ACV_N',
  'MERCH_PROMOTED_ACV_N',
  'MERCH_DIST_ACV_N',
  'MERCH_ACV_D',
  'MERCH_FEATUREONLY_UNITS',
  'MERCH_DISPLAYONLY_UNITS',
  'MERCH_FEATUREDISPLAY_UNITS',
  'MERCH_TPRONLY_UNITS',
  'MERCH_PROMOTED_UNITS']

export const Metric_Shipment_Fields = [
  'SHIPMENT_ORDER_QTY',
  'SHIPMENT_BUOM_QTY',
  'SHIPMENT_UNITS',
  'SHIPMENT_WT',
  'SHIPMENT_STAT',
  'SHIPMENT_LISTSLS',
  'SHIPMENT_NETLISTSLS',
  'SHIPMENT_PRFTCNTRB',
  'RETURN_ORDER_QTY',
  'RETURN_BUOM_QTY',
  'RETURN_UNITS',
  'RETURN_WT',
  'RETURN_STAT',
  'RETURN_LISTSLS',
  'RETURN_NETLISTSLS',
  'RETURN_PRFTCNTRB']

export const Metric_All_Additive_Fields = [
    ...Metric_Base_Fields,
    ...Metric_EDLP_Fields,
    ...Metric_Merch_Incr_Fields,
    ...Metric_Display_Incr_Fields,
    ...Metric_Total_Fields,
    ...Metric_Promo_Fields,
    ...Metric_NonPromo_Fields,
    ...Metric_Merch_Fields,
    ...Metric_Shipment_Fields]